<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
            <span class="text-muted fw-light">Refunds /</span> Refund List
        </h4>
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right:10px">
                    monetization_on
                </span>Refund List
            </mat-card-header>

            <hr class="mt-4 mb-4">

            <mat-card class="mt-3">
                <mat-card-actions>
                    <div class="text-align mt-3 mb-0 search">
                        <mat-form-field appearance="outline">
                            <mat-label>Search</mat-label>
                            <input matInput (keyup)="applyFilter($event)" #input>
                        </mat-form-field>
                    </div>
                </mat-card-actions>

                <mat-card-content>
                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="navs-pills-justified-tablesuccess" role="tabpanel">
                            <div class="card">
                                <table mat-table [dataSource]="dataSource" matSort
                                    (matSortChange)="announceSortChange($event)" class="mat-elevation-z8" [resizeColumn]="true">

                                    <ng-container matColumnDef="srNo">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by srNo" class="heading" [resizeColumn]="true" [index]="0">
                                            S.No</th>
                                        <td mat-cell *matCellDef="let element; let j = index">
                                            {{ (j+1) + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="refundReqOn">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by refundReqOn" class="heading" [resizeColumn]="true"
                                            [index]="1" style="width: 190px;"
                                            >Refund Requested On</th>
                                        <td mat-cell *matCellDef="let element">{{element.refundDate | date:'MM-dd-yyyy'}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="transRefNo">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by transRefNo" class="heading"
                                            [resizeColumn]="true" [index]="2">Transaction Reference No</th>
                                        <td mat-cell *matCellDef="let element"
                                            (click)="getRefundDetailsById(element.refundRequestId)"
                                            style="color: blue; cursor: pointer;"> {{element.afsTransactionId}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="refundAmount">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by refundAmount" class="heading"
                                            [resizeColumn]="true" [index]="3">Refund Amount</th>
                                        <td mat-cell *matCellDef="let element" style="text-align: right;">
                                            $&#8239;{{element.refundAmount}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="refundStatus">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by refundStatus" class="heading"
                                            [resizeColumn]="true" [index]="4">Refund Status</th>
                                        <!-- <td mat-cell *matCellDef="let element">
                                            <div *ngIf="element.isRefunded==0 && element.isCancelled==0">{{'Refund Processed'}}</div>
                                            <div *ngIf="element.isRefunded==1 && element.isCancelled==0">{{'Refunded'}}</div>
                                            <div *ngIf="element.isRefunded==0 && element.isCancelled==1 && element.refundAttempts==0">{{'Refund Cancelled'}}</div>
                                            <div *ngIf="element.isRefunded==1 && element.isCancelled==1">{{'Refunded'}}</div>
                                            <div *ngIf="element.refundAttempts>0 && !element.isRefunded && element.isCancelled==1">{{'Refund Failed'}}</div>
                                        </td> -->

                                        <td mat-cell *matCellDef="let element">
                                            <div *ngIf="element.isRefunded==0 && element.isCancelled==0 && element.refundAttempts==0">{{'Refund Processed'}}</div>
                                            <div *ngIf="element.isRefunded==1">{{'Refunded'}}</div>
                                            <div *ngIf="element.isCancelled==1 && element.isRefunded==0">{{'Refund Cancelled'}}</div>
                                            <div *ngIf="element.refundAttempts>0 && element.isRefunded==0 && element.isCancelled==0">{{'Refund Failed'}}
                                           </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cancel">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by cancel" class="heading"
                                            [resizeColumn]="true" [index]="5">Cancel Refund</th>

                                            <td mat-cell *matCellDef="let element">
                                                <div *ngIf="element.isCancelled==0 && element.isRefunded==0 && element.refundAttempts==0">
                                                    <button type="button" class="btn btn-primary mb-3 mt-3"
                                                        (click)="cancelRefund(element.refundRequestId)">Cancel</button>
                                                </div>
                                                <!-- <div *ngIf="element.isCancelled==1 && element.isRefunded==1">Can't cancelled</div>
                                                <div *ngIf="element.refundAttempts>0 && element.isRefunded==0 ">{{'Refund Failed'}}</div> -->
                                                <!-- <div *ngIf="element.isRefunded==0 && element.isCancelled==0">{{'Refund Processed'}}</div> -->
                                                <div *ngIf="element.isRefunded==1">{{"Can't Cancelled"}}
                                                </div>
                                                <div
                                                    *ngIf="element.isCancelled==1  && element.isRefunded==0">
                                                    {{'Refund Cancelled'}}</div>
                                                <!-- <div *ngIf="element.isRefunded==1 && element.isCancelled==1">{{"Can't Cancelled"}}</div> -->
                                                <div *ngIf="element.refundAttempts>0 && element.isRefunded==0 && element.isCancelled==0">{{'Refund Failed'}}</div>
                                            </td>
                                        <!-- <td mat-cell *matCellDef="let element">
                                            <div *ngIf="!element.isCancelled && !element.isRefunded">
                                                <button type="button" class="btn btn-primary mb-3 mt-3"
                                                    (click)="cancelRefund(element.refundRequestId)">Cancel</button>
                                            </div>
                                    
                                            <div *ngIf="element.isRefunded==1 && !element.isCancelled">{{"Can't Cancelled"}}</div>
                                            <div *ngIf="!element.refundAttempts && !element.isRefunded && element.isCancelled==1">{{'Refund Cancelled'}}</div>
                                            <div *ngIf="element.isRefunded==1 && element.isCancelled==1">{{"Can't Cancelled"}}</div>
                                            <div *ngIf="element.refundAttempts>0 && !element.isRefunded && element.isCancelled==1">{{'Refund Failed'}}
                                            </div>
                                        </td> -->
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" >No data matching the filter "{{input.value}}"
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <mat-card-actions>
                        <div class="text-align mt-3">
                            <mat-paginator #myPaginator [length]="totalCount" [pageSize]="pageSize"
                                [pageIndex]="pageIndex" [pageSizeOptions]="[5, 10, 25, 100]"
                                (page)="onPageChange($event)">
                            </mat-paginator>
                        </div>
                    </mat-card-actions>
                </mat-card-content>
            </mat-card>
        </mat-card>
    </div>
</div>
<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>